import type { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils/cn'

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-xl border border-slateish-200 bg-white shadow-sm', className)}
      {...props}
    />
  )
}

export function CardHeader({
  title,
  action,
  description,
}: {
  title: ReactNode
  action?: ReactNode
  description?: ReactNode
}) {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-slateish-200 px-5 py-4">
      <div>
        <h2 className="text-base font-semibold text-ink-700">{title}</h2>
        {description ? <p className="mt-1 text-sm text-slateish-600">{description}</p> : null}
      </div>
      {action}
    </div>
  )
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('px-5 py-4', className)} {...props} />
}
